export const arraysEqual = (arr1: string[], arr2: string[]): boolean => {
    return arr1.length === arr2.length && JSON.stringify(
        [...arr1].sort()) === JSON.stringify([...arr2].sort()
        );
};

// 配列の中のオブジェクトを指定したキーでソートする
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const sortByDateDesc = <T extends Record<string, any>>(arr: T[], sortKey: string): T[] => {
    return arr.sort((a, b) => {
        const dateA = new Date(a[sortKey]).getTime();
        const dateB = new Date(b[sortKey]).getTime();

        const idxA = arr.indexOf(a);
        const idxB = arr.indexOf(b);
        const originalOrder = idxB - idxA; // 元の順序を維持するための値

        // 無効な日付を一番下に移動
        if (isNaN(dateA) && isNaN(dateB)) {
            return originalOrder;
        }
        if (isNaN(dateA)) {
            return 1; // a が無効なら b を上に
        }
        if (isNaN(dateB)) {
            return -1; // b が無効なら a を上に
        }
        if (dateB - dateA === 0) {
            return originalOrder; // 元の順序を維持
        }

        return dateB - dateA;
    });
};

/* CSVデータを配列に変換 */
export const noticeCsvToArray = (csv: string) => {
    if (!csv.trim()) { return []; }

    const rows = csv.split('\n').filter(row => row.trim() !== ''); // 空行をスキップ
    const headers = rows[0].split(','); // ヘッダー行を取得
    const now = new Date(); // 現在の日時を取得

    const data = rows.slice(1).map(row => {
        const values = row.split(',').map(value => value.trim()); // 各値の前後の空白や改行を削除
        const obj = headers.reduce((obj: { [key: string]: string }, header, index) => {
            obj[header.trim()] = values[index]; // ヘッダーの前後の空白や改行を削除
            return obj;
        }, {});

        // 掲載開始日時と掲載終了日時をチェック
        const startDate = new Date(obj['掲載開始日時']);
        const endDate = new Date(obj['掲載終了日時']);

        if (startDate.getTime() <= now.getTime() && now.getTime() <= endDate.getTime()) {
            return obj;
        } else {
            return null;
        }
    }).filter(item => item !== null); // nullを除外

    return data;
};